<script>
export default {
  name: 'IconAiSparkle',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Estrela principal (4 pontas côncavas) — o "sparkle" universal de IA. -->
    <path
      d="M14 2.5Q14 10 21.5 10Q14 10 14 17.5Q14 10 6.5 10Q14 10 14 2.5Z"
      :fill="color"
    />
    <!-- Estrela menor, deslocada, reforça a leitura de "brilho"/IA. -->
    <path
      d="M6.5 13.5Q6.5 17.5 10.5 17.5Q6.5 17.5 6.5 21.5Q6.5 17.5 2.5 17.5Q6.5 17.5 6.5 13.5Z"
      :fill="color"
    />
  </svg>
</template>
